import React, { useState, useEffect } from 'react';
import { Button, Input } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Components/Siderbar'; 
import Footer from '../Components/Footer'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Customize_Css/AddVendor.css';
import '../Customize_Css/Banners.css';
import uploadicon from '../Icons/upload white.svg'; 
import removeicon from '../Icons/Close-white.svg'; 

export const AddBanner = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [bannerName, setBannerName] = useState('');
  const [bannerImage1, setBannerImage1] = useState(null);
  const [bannerImage2, setBannerImage2] = useState(null);
  const [linkType, setLinkType] = useState('Products');
  const [selectedLink, setSelectedLink] = useState('');
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [selectedVendorName, setSelectedVendorName] = useState('');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const AuthorizationToken = localStorage.getItem('token');
  // BearerToken
  console.log(AuthorizationToken,'tokennnnnnnnnnnnnn')

  console.log('Base URL:', BASE_URL);

  // Fetch Vendors
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await fetch(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`,
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        const data = await response.json();
        if (data.vendors) {
          setVendors(data.vendors);
        } else {
          console.error('No vendors found');
        }
      } catch (error) {
        console.error('Error fetching vendor data:', error);
        toast.error('Error fetching vendors');
      }
    };

    fetchVendors();
  }, [epicxTenantId, BASE_URL]);

  // Fetch Categories
  const fetchActiveCategories = async () => {
    try {
      const response = await fetch(`${BASE_URL}/products/api/category/`,
       { headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },}
      );
      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Error fetching categories');
    }
  };

  // Fetch SubCategories
  const fetchSubCategories = async () => {
    try {
      const response = await fetch(`${BASE_URL}/products/api/sub-category/subcategory`,
        { headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },}
      );
      if (!response.ok) {
        throw new Error('Failed to fetch subcategories');
      }
      const data = await response.json();
      setSubCategories(data);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      toast.error('Error fetching subcategories');
    }
  };

  // Fetch Products by Vendor
  const fetchProductsByVendor = async (vendorId) => {
    try {
      const response = await fetch(`${BASE_URL}/products/api/productDetails/products/${vendorId}`,
        { headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },}
      );
      const data = await response.json();
      if (response.ok && data.length > 0) {
        setProducts(data);
      } else {
        setProducts([]);
        // toast.info('No products found for this vendor');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Error fetching products');
    }
  };

  // Handle Vendor Change
  const handleVendorChange = (e) => {
    const vendorId = e.target.value;
    setSelectedVendor(vendorId);
    setSelectedLink(''); // Reset selected link when vendor changes

    if (vendorId) {
      const vendor = vendors.find((v) => v._id === vendorId);
      setSelectedVendorName(vendor?.vendorName || '');
      if (linkType === 'Products') {
        fetchProductsByVendor(vendorId);
      }
    } else {
      setSelectedVendorName('');
      setProducts([]);
    }
  };

  // Fetch data based on linkType
  useEffect(() => {
    if (linkType === 'Category') {
      fetchActiveCategories();
    } else if (linkType === 'Products' && selectedVendor) {
      fetchProductsByVendor(selectedVendor);
    } else if (linkType === 'SubCategory') {
      fetchSubCategories();
    }
  }, [linkType, selectedVendor, BASE_URL]);

  // Handle File Changes
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setBannerImage1(selectedFile);
  };

  const handleRemoveFile = () => {
    setBannerImage1(null);
  };

  const handleFileChange2 = (event) => {
    const selectedFile = event.target.files[0];
    setBannerImage2(selectedFile);
  };

  const handleRemoveFile2 = () => {
    setBannerImage2(null);
  };

  // Handle Link Type Change
  const handleLinkTypeChange = (type) => {
    setLinkType(type);
    setSelectedLink(''); // Reset selected link when link type changes
  };

  // Form Validation
  const validateBannerForm = () => {
    let errors = {};
    let valid = {};
    let isValid = true;

    if (!bannerName || bannerName.trim() === "") {
      errors.bannerName = "Banner Name is required";
      isValid = false;
    } else {
      valid.bannerName = true;
    }

    if (!bannerImage1) {
      errors.bannerImage1 = "Banner Image 1 is required";
      isValid = false;
    } else {
      valid.bannerImage1 = true;
    }

    if (!bannerImage2) {
      errors.bannerImage2 = "Banner Image 2 is required";
      isValid = false;
    } else {
      valid.bannerImage2 = true;
    }

    if (!selectedVendor) {
      errors.selectedVendor = "Select Product Vendor is required";
      isValid = false;
    } else {
      valid.selectedVendor = true;
    }

    if (!selectedLink) {
      errors.selectedLink = "A reference link is required";
      isValid = false;
    } else {
      valid.selectedLink = true;
    }

    setErrors(errors);
    setValidFields(valid);

    return isValid;
  };

  // Handle Form Submission
  const handleSubmit = async () => {
    if (!validateBannerForm()) {
      toast.error('Please fill all required fields');
      return;
    }

    const formData = new FormData();
    formData.append('bannerName', bannerName);
    formData.append('associatedWith', linkType === 'Products' ? 'Product' : linkType); // Map 'Products' to 'Product'
    formData.append('referenceId', selectedLink); // ObjectId of Product/Category/SubCategory
    formData.append('bannerImage1', bannerImage1);
    formData.append('bannerImage2', bannerImage2);
    formData.append('productVendorId', selectedVendor);
    formData.append('productVendorName', selectedVendorName);

    // Log FormData for debugging
    for (let pair of formData.entries()) {
      if (pair[0].includes('bannerImage')) {
        console.log(`${pair[0]}: ${pair[1].name}`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }

    try {
      const response = await fetch(`${BASE_URL}/products/api/banners/${epicxTenantId}`,
      {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (response.ok && result.statusCode === 1) {
        console.log('Success:', result);
        toast.success('Banner submitted successfully');
        // Reset form
        setBannerName('');
        setBannerImage1(null);
        setBannerImage2(null);
        setSelectedLink('');
        setSelectedVendor('');
        setSelectedVendorName('');
        setProducts([]);
      } else {
        toast.error(result.message || 'Failed to submit banner');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error(`Error: ${error.message || 'Something went wrong'}`);
    }
  };

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">Sales</p>
              <h1>Add Banner</h1>
              <p>Name the banner, choose a vendor, upload both images, and link it. Required fields stay the same.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={() => navigate('/viewBanners')}>
              Back to Banners
            </button>
          </header>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Banner Information</h2>
                <p>Images, vendor, and where this banner should open.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="bannerName">Banner Name</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.bannerName ? 'is-invalid' : validFields.bannerName ? 'is-valid' : ''}`}
                      id="bannerName"
                      value={bannerName}
                      onChange={(e) => setBannerName(e.target.value)}
                      placeholder="Enter banner name"
                    />
                    {errors.bannerName && <small className="text-danger">{errors.bannerName}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="productVendor">Product Vendor</label>
                    <span style={{ color: 'red' }}>*</span>
                    <select
                      id="productVendor"
                      className={`form-select bg-light ${errors.selectedVendor ? 'is-invalid' : validFields.selectedVendor ? 'is-valid' : ''}`}
                      value={selectedVendor}
                      onChange={handleVendorChange}
                    >
                      <option value="">Select Product Vendor</option>
                      {vendors.length > 0 ? (
                        vendors.map((vendor) => (
                          <option key={vendor._id} value={vendor._id}>
                            {`${vendor.vendorName} (${vendor.emailAddress})`}
                          </option>
                        ))
                      ) : (
                        <option disabled>No vendors available</option>
                      )}
                    </select>
                    {errors.selectedVendor && <small className="text-danger">{errors.selectedVendor}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="bannerImage1">Banner Image 1</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="form-group">
                      <label className="vendor-upload-label" htmlFor="file-upload-button">
                        <Input
                          accept="image/*"
                          id="file-upload-button"
                          type="file"
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                        />
                        <Button
                          variant="contained"
                          component="span"
                          className="vendor-field-action"
                          endIcon={
                            bannerImage1 ? (
                              <img src={removeicon} alt="Remove Icon" style={{ width: '20px', height: '20px' }} />
                            ) : (
                              <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
                            )
                          }
                          onClick={bannerImage1 ? handleRemoveFile : null}
                        >
                          {bannerImage1 ? bannerImage1.name : 'Upload Image'}
                        </Button>
                      </label>
                      {errors.bannerImage1 && <small className="text-danger">{errors.bannerImage1}</small>}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="bannerImage2">Banner Image 2</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="form-group">
                      <label className="vendor-upload-label" htmlFor="file-upload-button2">
                        <Input
                          accept="image/*"
                          id="file-upload-button2"
                          type="file"
                          onChange={handleFileChange2}
                          style={{ display: 'none' }}
                        />
                        <Button
                          variant="contained"
                          component="span"
                          className="vendor-field-action"
                          endIcon={
                            bannerImage2 ? (
                              <img src={removeicon} alt="Remove Icon" style={{ width: '20px', height: '20px' }} />
                            ) : (
                              <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
                            )
                          }
                          onClick={bannerImage2 ? handleRemoveFile2 : null}
                        >
                          {bannerImage2 ? bannerImage2.name : 'Upload Image'}
                        </Button>
                      </label>
                      {errors.bannerImage2 && <small className="text-danger">{errors.bannerImage2}</small>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label>Link To</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="banner-link-toggle" role="group" aria-label="banner link type">
                      <button type="button" className={linkType === 'Products' ? 'is-active' : ''} onClick={() => handleLinkTypeChange('Products')}>Product</button>
                      <button type="button" className={linkType === 'Category' ? 'is-active' : ''} onClick={() => handleLinkTypeChange('Category')}>Category</button>
                      <button type="button" className={linkType === 'SubCategory' ? 'is-active' : ''} onClick={() => handleLinkTypeChange('SubCategory')}>SubCategory</button>
                    </div>
                  </div>
                  <div className="col-md-4">
                    {linkType === 'Products' ? (
                      <>
                        <label htmlFor="products">Select Product</label>
                        <span style={{ color: 'red' }}>*</span>
                        <select
                          id="products"
                          className={`form-select bg-light ${errors.selectedLink ? 'is-invalid' : validFields.selectedLink ? 'is-valid' : ''}`}
                          value={selectedLink}
                          onChange={(e) => setSelectedLink(e.target.value)}
                        >
                          <option value="">Choose Product</option>
                          {products.length > 0 ? (
                            products.map((product) => (
                              <option key={product._id} value={product._id}>
                                {product.productName}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No Products Available</option>
                          )}
                        </select>
                        {errors.selectedLink && <small className="text-danger">{errors.selectedLink}</small>}
                      </>
                    ) : linkType === 'Category' ? (
                      <>
                        <label htmlFor="categories">Select Category</label>
                        <span style={{ color: 'red' }}>*</span>
                        <select
                          id="categories"
                          className={`form-select bg-light ${errors.selectedLink ? 'is-invalid' : validFields.selectedLink ? 'is-valid' : ''}`}
                          value={selectedLink}
                          onChange={(e) => setSelectedLink(e.target.value)}
                        >
                          <option value="">Choose Category</option>
                          {categories.length > 0 ? (
                            categories.map((category) => (
                              <option key={category._id} value={category._id}>
                                {category.categoryName}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No Categories Available</option>
                          )}
                        </select>
                        {errors.selectedLink && <small className="text-danger">{errors.selectedLink}</small>}
                      </>
                    ) : linkType === 'SubCategory' ? (
                      <>
                        <label htmlFor="subcategories">Select SubCategory</label>
                        <span style={{ color: 'red' }}>*</span>
                        <select
                          id="subcategories"
                          className={`form-select bg-light ${errors.selectedLink ? 'is-invalid' : validFields.selectedLink ? 'is-valid' : ''}`}
                          value={selectedLink}
                          onChange={(e) => setSelectedLink(e.target.value)}
                        >
                          <option value="">Choose SubCategory</option>
                          {subCategories.length > 0 ? (
                            subCategories.map((subCategory) => (
                              <option key={subCategory._id} value={subCategory._id}>
                                {subCategory.subCategoryName}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No SubCategories Available</option>
                          )}
                        </select>
                        {errors.selectedLink && <small className="text-danger">{errors.selectedLink}</small>}
                      </>
                    ) : null}
                  </div>
                </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={() => navigate('/viewBanners')}>Cancel</button>
            <button type="button" className="vendor-form-submit" onClick={handleSubmit}>Save and Submit</button>
          </div>
        </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </div>
    </>
  );
};